module.exports = __webpack_public_path__ + "static/quote4-7cc1141a80b5ed9f1c35627706510c91.jpg";